<template>
    <div>
        <!-- NAV -->
        <div class="row">
            <div class="col-5">
                <b-breadcrumb>
                    <b-breadcrumb-item :to="{name: 'page-list'}">
                        Page List
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ page.key }}</b-breadcrumb-item>
                </b-breadcrumb>
            </div>
            <div class="col-7">
                <b-btn class="float-right" size="lg" variant="primary" @click="savePage" ref="saveBtn" :disabled="saving">
                    Save Page
                </b-btn>
                <b-btn class="float-right mx-2" size="lg" variant="success"  ref="saveBtn" :disabled="saving" :to="{name: 'block-editor'}">
                    Edit Blocks
                </b-btn>
            </div>
        </div>
        <!-- Page -->
<!--        <h3>{{page.id}}</h3>-->

        <!-- Main Editor -->
        <section>
            <!-- Title -->
            <b-input-group prepend="Title" class="mb-3"><b-input type="text" v-model="page.title" /></b-input-group>
            <b-input-group prepend="Description" class="mb-3"><b-input type="text" v-model="page.description" /></b-input-group>

<!--            TODO: Add State/Global Message (homeschool toggle)-->

            <!-- Images -->
            <b-card body-class="p-0" class="mb-3">
                <template #header>
                    <h3 class="d-inline-block w-100">
                        Resources
                        <b-btn variant="info" class="float-right" :to="{name:'images'}">Edit Resources</b-btn>
                    </h3>
                </template>
                <b-table :items="folderMappings" :fields="resourceMapTableFields" sticky-header :busy="isLoading" striped tbody-tr-class="m-0 p-0" selectable @row-selected="setSelectedMap" selected-variant="primary">
                    <template #cell(map_type)="data">
                        <span v-if="data.item.map_type == 'page'">Page</span>
                        <span v-if="data.item.map_type == 'product'">Product</span>
                    </template>
                    <template #cell(map_id)="data">
                            <span v-if="data.item.map_type == 'page'">
                                <span v-for="(page, i) in pages" v-if="page.id == data.item.map_id">{{page.title}}</span>
                            </span>
                        <span v-if="data.item.map_type == 'product'">
                                {{data.item.map_id}}
                            </span>
                    </template>
                </b-table>
                <b-container v-if="selectedResourceMap">
                    <b-card v-for="(item, i) in folderResources"
                            :key="`img_${i}`"
                            style="width:150px; height: 150px;"
                            class="m-2"
                            body-class="p-0 m-0"
                    >
                        <a href="javascript:void(0)" @click.prevent="openViewer(item)">
                            <!--                            <template #header>{{item}}</template>-->
                            <b-card-img :src="imageUrl(item)" style="border: 2px solid black; border-radius: 5px"></b-card-img>
                        </a>

                    </b-card>
                </b-container>
            </b-card>
            <!-- Pubs -->
            <b-card>
                <!-- HEADER -->
                <template #header>
                    <h3 class="d-inline-block">Publications</h3>
                    <span id="pub_info" class="float-right pt-1" v-b-popover.hover.top="">
                        <font-awesome-icon :icon="['fas','info-circle']"/>
                    </span>
                    <b-btn variant="info" class="float-right mr-2" v-b-toggle:product_collapse>
                        <template v-if="productPageShowing">
                            Hide <font-awesome-icon :icon="['fas', 'caret-up']" class=""/>
                        </template>
                        <template v-else>
                            Show <font-awesome-icon :icon="['fas', 'caret-down']" class=""/>
                        </template>

                    </b-btn>

                    <div>
                    <b-checkbox v-model="viewHomeschool" class="d-inline-block ml-3 mt-2" @input="setHomeschool">View as Homeschool</b-checkbox>
                    <multiselect id="state"
                         v-model="selectedState"
                         :options="states"
                         label="fullState"
                         name="state"
                         track-by="state"
                         placeholder="Select State"
                         select-label=""
                         deselect-label=""
                         :searchable="true"
                         :multiple="false"
                         class="w-25 d-inline-block ml-5"
                         @input="getProducts"
                         :preselect-first="true"
                    />
                    <b-select v-model="selectedSchoolYear" :value="schoolYear" class="d-inline-block ml-5 w-25" @input="getProducts">
                        <b-select-option :value="actualSchoolYear-2">{{actualSchoolYear-3}}-{{actualSchoolYear-2}}</b-select-option>
                        <b-select-option :value="actualSchoolYear-1">{{actualSchoolYear-2}}-{{actualSchoolYear-1}}</b-select-option>
                        <b-select-option :value="actualSchoolYear">{{actualSchoolYear-1}}-{{actualSchoolYear}}</b-select-option>
                        <b-select-option :value="actualSchoolYear+1">{{actualSchoolYear}}-{{actualSchoolYear+1}}</b-select-option>
                        <b-select-option :value="actualSchoolYear+2">{{actualSchoolYear+1}}-{{actualSchoolYear+2}}</b-select-option>
                    </b-select>
                    </div>
                    <div class="loader d-inline-block" v-if="isLoading"></div>

                    <b-popover target="pub_info" triggers="hover" placement="top">
                        If a publication isn't showing below, verify the following in SWO: <br/>
                        1. Is it 'Visible in Store'?<br/>
                        2. Is the Physical SKU (legacy id) set?
                        3. Is it grade/state mapped?
                    </b-popover>

                </template>
                <!-- Filters & Table -->
                <template #default >
                    <b-collapse id="product_collapse" v-model="productPageShowing">

                        <!-- Ez Filters -->
                        <b-row class="" v-show="!isLoading">
                            <b-col>
                                Grades:<br/>
                                <b-btn-group>
                                    <b-btn v-for="(i) in 10" :pressed.sync="gradeFilter[i-2]" :variant="gradeFilter[i-2] ? 'primary':  'light'"
                                           @click="updateGradeFilters"
                                           class="border-dark">
                                        {{i-2}}
                                    </b-btn>
                                </b-btn-group>
                            </b-col>
                            <b-col>
                                <br/>
                                <multiselect id="topic"
                                     v-model="topicFilters"
                                     :options="topicOptions"
                                     label="topic"
                                     name="topic"
                                     track-by="id"
                                     select-label=""
                                     deselect-label=""
                                     placeholder="Topics"
                                     :searchable="true"
                                     :multiple="true"
                                     class="mb-2"
                                     @input="updateTopicFilters"
                                >
                                </multiselect>
                            </b-col>
                            <b-col>
                                <br/>
                                <multiselect id="languages"
                                     v-model="langFilters"
                                     :options="languageOptions"
                                     label="name"
                                     track-by="language"
                                     select-label=""
                                     deselect-label=""
                                     name="language"
                                     placeholder="Languages"
                                     :searchable="true"
                                     :multiple="true"
                                     @input="updateLanguageFilters"
                                >
                                </multiselect>
                            </b-col>

                        </b-row>

                        <!-- Filters-->
                        <div class="mb-3" v-show="!isLoading">
                            <div class="row">
                                <div class="col-10 my-0 pt-1">
                                    Filters:
                                </div>
                                <div class="col-2">
                                    <b-btn size="sm" variant="primary" class="float-right p-0 px-1" @click="$bvModal.show('addFilterModal')">
                                        Add Filter [<font-awesome-icon :icon="['fas', 'plus']"/>]
                                    </b-btn>
                                </div>
                            </div>
                            <div class="row filters-list py-1">
                                <span v-for="(filter, i) in page.filters" class="mx-2">
                                    <b-badge :variant="getFilterVariant(filter)">
                                        <a @click="editFilter(filter)">{{getFilterText(filter)}}</a>
                                        <span v-if="filter.homeschool === 0" class="mx-1">
                                            <font-awesome-icon :icon="['fas', 'school']" v-b-popover.hover.top="'School Only'"/>
                                        </span>
                                        <span v-if="filter.homeschool === 1" class="mx-1">
                                            <font-awesome-icon :icon="['fas', 'home']" v-b-popover.hover.top="'Homeschool Only'"/>
                                        </span>
                                        <b-btn :variant="getFilterVariant(filter)" size="sm" class="p-0" @click="removeFilter(i)">
                                            <font-awesome-icon :icon="['far', 'times-circle']" class="filter-delete-btn"/>
                                        </b-btn>
                                    </b-badge>
                                </span>
                            </div>
                        </div>

                        <!-- Pubs Table -->
                        <b-table :items="filteredProducts" :fields="publicationTableFields" v-if="filteredProducts.length" :busy="isLoading || saving">

                            <template #cell(sku)="data">
                                <strong :id="data.item.sku" v-b-popover.hover.top="">{{data.item.sku}}</strong>
                                <b-popover :target="data.item.sku" triggers="hover" placement="top">
                                    {{data.item.title}}
                                </b-popover>
                            </template>
                            <template #cell(language)="data">
                                <span :class="{'lang-en': data.item.language == 'en', 'lang-es': data.item.language == 'es'}">{{data.item.language}}</span>
                            </template>

                            <template #cell(grade)="data">
                                <b-btn :class="{
                                'pre-k': data.item.grade == -1,
                                'kindergarten': data.item.grade == 0,
                                'first-grade': data.item.grade == 1,
                                'second-grade': data.item.grade == 2,
                                'third-grade': data.item.grade == 3,
                                'fourth-grade': data.item.grade == 4,
                                'fifth-grade': data.item.grade == 5,
                                'sixth-grade': data.item.grade == 6,
                                'seventh-grade': data.item.grade == 7,
                                'eighth-grade': data.item.grade == 8,
                                }"
                                class="text-light p-2" style="width:45px">{{data.item.grade}}</b-btn>
                            </template>

                            <template #cell(subject)="data">
                                <strong :class="{
                                'topic-ss': data.item.subject == 'social_studies',
                                'topic-sn': data.item.subject == 'science',
                                'topic-hw': data.item.subject == 'health_wellness',
                                'topic-other': data.item.subject == 'other',
                                }">{{data.item.subject}}</strong>
                            </template>

                        </b-table>
                    </b-collapse>
                </template>
            </b-card>
        </section>

        <!-- Add Filter Modal -->
        <b-modal id="addFilterModal" @ok="saveNewFilter()" @hidden="resetEditFilter()" size="lg">
            <template #modal-header>
                <span v-if="filterToEdit !== null">Edit Product Filter<br/></span>
                <span v-else>Create Product Filter</span>
            </template>

            <b-input-group class="mb-1">
                <b-checkbox v-model="newFilter.active" :unchecked-value="0" :value="1">Active</b-checkbox>
            </b-input-group>
            <b-input-group prepend="Title" class="mb-3">
                <b-input v-model="newFilter.title" placeholder="Title, to help understand its goal"/>
            </b-input-group>

            <b-input-group prepend="Notes" class="mb-3">

                <b-form-textarea row="1" max-rows="6" v-model="newFilter.description" placeholder="Notes, for reference and to explain why this filter is needed"/>
            </b-input-group>

            <b-input-group prepend="Homeschool" class="mb-3">
                <b-select v-model="newFilter.homeschool">
                    <b-select-option :value="null">Applies to Both</b-select-option>
                    <b-select-option :value="1">Homeschool Only</b-select-option>
                    <b-select-option :value="0">Store Only</b-select-option>
                </b-select>
            </b-input-group>
            <b-input-group prepend="Select States" class="mb-3">
                <multiselect id="filter_selected_state"
                             v-model="newFilter.selected_states"
                             :options="[{state: null, fullState: 'All',},...states]"
                             placeholder="Applies in States"
                             label="fullState"
                             name="state"
                             track-by="state"
                             select-label=""
                             deselect-label=""
                             :searchable="true"
                             :multiple="true"
                             class="d-inline-block w-50"
                />
                <template #append v-if="newFilter && newFilter.selected_states != null">
                    <b-btn v-if="!newFilter.selected_states.length" class="d-inline-block p-0 px-3 m-0" @click="selectAllStatesForFilter">Select All</b-btn>
                    <b-btn v-else class="d-inline-block p-0 px-3 m-0" @click="selectAllStatesForFilter(false)">Clear All</b-btn>
                </template>
            </b-input-group>
            <!-- School Year -->
            <b-input-group prepend="School Year Range">
                <b-select v-model="newFilter.min_school_year" :value="null">
                    <b-select-option :value="null">Beginning of Time</b-select-option>
                    <b-select-option :value="schoolYear-2">{{schoolYear-3}}-{{schoolYear-2}}</b-select-option>
                    <b-select-option :value="schoolYear-1">{{schoolYear-2}}-{{schoolYear-1}}</b-select-option>
                    <b-select-option :value="schoolYear">{{schoolYear-1}}-{{schoolYear}}</b-select-option>
                    <b-select-option :value="schoolYear+1">{{schoolYear}}-{{schoolYear+1}}</b-select-option>
                    <b-select-option :value="schoolYear+2">{{schoolYear+1}}-{{schoolYear+2}}</b-select-option>
                </b-select>
                <span class="mt-2">- to -</span>
                <b-select v-model="newFilter.max_school_year">
                    <b-select-option :value="schoolYear-2">{{schoolYear-3}}-{{schoolYear-2}}</b-select-option>
                    <b-select-option :value="schoolYear-1">{{schoolYear-2}}-{{schoolYear-1}}</b-select-option>
                    <b-select-option :value="schoolYear">{{schoolYear-1}}-{{schoolYear}}</b-select-option>
                    <b-select-option :value="schoolYear+1">{{schoolYear}}-{{schoolYear+1}}</b-select-option>
                    <b-select-option :value="schoolYear+2">{{schoolYear+1}}-{{schoolYear+2}}</b-select-option>
                    <b-select-option :value="null">End of Time</b-select-option>
                </b-select>
            </b-input-group>
            <div class="mb-3"><small>*ranges inclusive</small></div>


            <b-input-group prepend="type" class="mb-3">
                <b-select v-model="newFilter.type">
                    <b-select-option value="and">And (All products must have this)</b-select-option>
                    <b-select-option value="or">Or (Specific variability)</b-select-option>
                    <b-select-option value="blackout">Blackout (Remove products that match)</b-select-option>
                </b-select>
            </b-input-group>
            <b-input-group prepend="Filter" class="mb-3">
                <b-select v-model="newFilter.filterBy">
                    <b-select-option disabled :value="null">(Select One)</b-select-option>
                    <b-select-option :value="filterTypes.topic">Topic</b-select-option>
                    <b-select-option :value="filterTypes.grade">Grade</b-select-option>
                    <b-select-option :value="filterTypes.language">Language</b-select-option>
                    <b-select-option :value="filterTypes.state">State</b-select-option>
                    <b-select-option :value="filterTypes.specific">Sku</b-select-option>
                </b-select>
            </b-input-group>

            <!-- Filter Forms -->
            <!-- Topic -->
            <div v-if="newFilter.filterBy === filterTypes.topic">
                <b-input-group prepend="Topic"> <b-input type="text" v-model="newFilter.topic" placeholder="social-studies"/></b-input-group>
            </div>
            <!-- Grade -->
            <div v-if="newFilter.filterBy === filterTypes.grade">
                <b-input-group prepend="Grade"> <b-input type="number" v-model="newFilter.grade" placeholder="number"/></b-input-group>
            </div>
            <!-- Language -->
            <div v-if="newFilter.filterBy === filterTypes.language">
                <b-input-group prepend="Language">
                    <b-select type="text" v-model="newFilter.language">
                        <b-select-option value="en">English</b-select-option>
                        <b-select-option value="es">Spanish</b-select-option>
                    </b-select>
                </b-input-group>
            </div>
            <!-- State -->
            <div v-if="newFilter.filterBy === filterTypes.state">
                <multiselect id="state-filter"
                             v-model="newFilter.state"
                             :options="states"
                             placeholder="Select State"
                             label="fullState"
                             name="state"
                             track-by="state"
                             select-label=""
                             deselect-label=""
                             :searchable="true"
                             :multiple="false"
                             class="d-inline-block"
                />
<!--                <b-input-group prepend="State"> <b-input type="text" v-model="newFilter.state"/></b-input-group>-->
            </div>

            <!-- Sku -->
            <div v-if="newFilter.filterBy === filterTypes.specific">
                <b-checkbox v-model="newFilter.isRegex" unchecked-value="0" value="1">Regex</b-checkbox>

                <b-input-group>
                    <template #prepend>
                        <div class="input-group-text">Sku</div>
                        <div class="input-group-text text-muted" v-if="newFilter.isRegex ==1">/</div>
                    </template>
                    <b-input type="text" v-model="newFilter.sku" placeholder="SW-01-SS-EN-V1"/>
                    <template #append>
                        <div class="input-group-text text-muted" v-if="newFilter.isRegex ==1">/</div>
                    </template>
                </b-input-group>

                <ul>
                    <li v-for="(product, i) in regexProducts">{{product.sku}}</li>
                </ul>
            </div>
            <template #modal-ok>Ok</template>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {applyFilter, filterMethods, filterTypes} from "@/common/publicationFilters";
import {publicationStates, stateCodes} from "@/common/states";
import {imageUrl} from "@/common/utils";


export default {
    name: "PageEditor",
    props: ['id'],
    data: () => ({
        states: publicationStates,
        statesByCode: stateCodes,
        selectedState: null,
        selectedSchoolYear: null,
        viewHomeschool: false,
        products: [],
        filteredProducts: [],
        saving: false,
        isLoading: false,
        productPageShowing: false,
        filterToEdit: null,
        folderMappings: [],
        folderResources: [],
        selectedResourceMap: null,

        // Page Filters
        blacklisted: {},
        newFilter: {active: 1, type:'and', homeschool: null, selected_states: [], min_school_year: null, max_school_year: null,},
        whitelisted: {},
        filterTypes: filterTypes,
        filterMethods: filterMethods,

        // Table Fields & Filters
        publicationTableFields: [
            {key:'legacy_id', sortable: true},
            {key:'sku', sortable: true},
            {key:'grade', sortable:true},
            {key:'language', sortable:true},
            {key:'subject', sortable:true},
            {key:'availability', sortable:true},
        ],
        resourceMapTableFields: [
            {key:'folder.name', label: 'Folder', sortable: true},
            {key:'map_type', label: 'Type', sortable: true},
            {key:'map_id', label: 'ID', sortable: true},
            {key:'actions', label: 'Actions'},
        ],

        // Ez Filters
        gradeFilter: {
            [-1]: false,
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
            7: false,
            8: false
        },
        langFilters: [],
        languageOptions: [],
        topicFilters: [],
        topicOptions: [],
    }),
    computed: {
        ...mapState({
            pages: state => state.stateData.pages,
            storeSelectedState: state => state.stateData.selectedState,
            schoolYear: state => state.stateData.currentSchoolYear,
        }),
        actualSchoolYear() {
            return this.$store.getters.getActiveSchoolYear;
        },
        gradeFilters() {
            let filters = [];
            for (let i = 0; i < this.page.filters.length; ++i) {
                if (this.page.filters[i].filterBy === this.filterTypes.grade)
                    filters.push(this.page.filters[i]);
            }
            return filters;
        },
        subjectFilters() {
            let filters = [];
            for (let i = 0; i < this.page.filters.length; ++i) {
                if (this.page.filters[i].filterBy === this.filterTypes.topic)
                    filters.push(this.page.filters[i]);
            }
            return filters;
        },
        languageFilters() {
            let filters = [];
            for (let i = 0; i < this.page.filters.length; ++i) {
                if (this.page.filters[i].filterBy === this.filterTypes.language)
                    filters.push(this.page.filters[i]);
            }
            return filters;
        },
        regexProducts() {
            // if (!this.newFilter.isRegex)
            //     return [];

            return this.filteredProducts.filter((a) => {
                return a.sku.match(this.newFilter.sku);
            });
        },
        page() {
            for (let i = 0; i < this.pages.length; ++i) {
                if (this.pages[i].id != this.id) continue;

                return this.pages[i];
            }

            return {
                id: null,
                key: "",
                title: "",
                description: "",
                filters: [],
                favored_skus: [],
                blacklisted_skus: [],
                blocks: [], // blocks for this page
            };
        }
    },
    created() {
        this.viewHomeschool = this.$store.getters.isHomeschoolStore;
        localStorage.getItem("productPageShowing") === 'true' ? this.productPageShowing = true : this.productPageShowing = false;
        this.selectedSchoolYear = this.schoolYear;
    },
    mounted() {
        this.page.id = this.id;

        this.getResourceMaps();
        // Add filter options
        this.languageOptions = [
            {filterBy: this.filterTypes.language, type: 'and', language: "en", name: 'English'},
            {filterBy: this.filterTypes.language, type: 'and', language: "es", name: 'Spanish'},
        ];
        this.topicOptions = [
            {filterBy: this.filterTypes.topic, type: 'and', topic: "social_studies", name: 'Social Studies'},
            {filterBy: this.filterTypes.topic, type: 'and', topic: "science", name: 'Science'},
            {filterBy: this.filterTypes.topic, type: 'and', topic: "health_wellness", name: 'Health Wellness'},
            {filterBy: this.filterTypes.topic, type: 'and', topic: "other", name: 'Other'},
        ];

        // Add existing filters
        if (this.gradeFilters.length)
            this.gradeFilters.forEach((filter) => {
                this.gradeFilter[filter.grade] = true;
            });
        if (this.languageFilters.length)
            this.langFilters.push(...this.languageFilters);
        if (this.subjectFilters.length)
            this.topicFilters.push(...this.subjectFilters);

    },
    watch: {
        selectedState(val) {
            this.$store.commit('setSelectedState', val.state);
        },
        selectedSchoolYear(val) {
            if (val == null)
                return;

            console.log("school year set: " + val);
            this.$store.commit('setSchoolYear', val);
        },
        productPageShowing(val) {
            localStorage.setItem('productPageShowing', val);
        },
    },
    beforeDestroy() {
        let year = this.$store.getters.getActiveSchoolYear;
        this.$store.commit('setSchoolYear', year);
    },
    methods: {
        async setHomeschool() {
            this.$store.commit('setHomeschoolStore', this.viewHomeschool);
            this.getProducts();
        },
        async getProducts() {
            this.isLoading = true;
            let response = await this.axios.get(`/product/publications/${this.selectedState.state}`, {params: {homeschool: this.viewHomeschool, year: this.selectedSchoolYear}})
            this.stateProducts = response.data;
            this.filterProducts();
            this.isLoading = false;
        },
        async getResourceMaps() {
            this.isLoading = true;
            let response = await this.axios.get(`/images/page/${this.page.id}/maps/`);
            this.folderMappings = response.data;
            this.isLoading = false;
        },
        async getResources() {
            this.isLoading = true;
            let response = await this.axios.get(`/images/mapping/${this.selectedResourceMap.id}/`);
            this.folderResources = response.data;
            this.isLoading = false;
        },
        filterProducts() {
            this.filteredProducts = applyFilter(this.stateProducts, this.page.filters);
            return;
        },
        resetEditFilter() {
            this.filterToEdit = null;
            this.newFilter = {active: 1, type:'and', homeschool: null, selected_states: [], min_school_year: null, max_school_year: null,};
        },
        editFilter(filter) {
            this.newFilter = Object.assign({active: 1, type:'and', homeschool: null, selected_states: [], min_school_year: null, max_school_year: null,}, filter);
            this.filterToEdit = filter;
            this.$bvModal.show('addFilterModal')
        },
        saveNewFilter() {
            // State is stored as an object {fullState: 'Utah', state: 'UT'}
            if (this.newFilter.hasOwnProperty('state')) {
                this.newFilter.state = this.newFilter.state.state;
            }

            // Update existing filter
            if (this.filterToEdit != null) {
                let index = this.page.filters.findIndex((a) => a === this.filterToEdit);
                if (index !== -1) {
                    console.log("Editing Filter");
                    this.page.filters[index] = Object.assign({}, this.newFilter);
                    this.resetEditFilter();
                    this.filterProducts();
                    return;
                }
            }

            // create new filter
            console.log("Creating new Filter");
            this.page.filters.push({...this.newFilter});
            this.resetEditFilter();
            this.filterProducts();
        },
        removeFilter(index) {
            let filter = this.page.filters[index];
            this.page.filters.splice(index, 1);

            // Remove from ez filters
            if (filter.filterBy === this.filterTypes.language) {
                this.langFilters.splice(this.langFilters.findIndex((a) => a.language === filter.language), 1);
            }
            if (filter.filterBy === this.filterTypes.topic) {
                this.topicFilters.splice(this.topicFilters.findIndex((a) => a.topic === filter.topic), 1);
            }
            if (filter.filterBy === this.filterTypes.grade) {
                this.gradeFilter[filter.grade] = false;
            }
            this.filterProducts();
        },
        getFilterVariant(filter) {
            if (filter.hasOwnProperty('active') && filter.active !== 1)
                return 'secondary'

            if (filter.type === 'and')
                return 'primary';

            if (filter.type === 'or')
                return 'success';

            if (filter.type === 'blackout')
                return 'danger';

            return 'secondary';
        },
        getFilterText(filter) {
            if (filter.title != null && filter.title.trim() !== "")
                return filter.title;

            if (filter.filterBy === this.filterTypes.topic)
                return `Topic: ${filter.topic}`;

            if (filter.filterBy === this.filterTypes.grade)
                return `Grade: ${filter.grade}`;

            if (filter.filterBy === this.filterTypes.language)
                return `Language: ${filter.language}`;

            if (filter.filterBy === this.filterTypes.state)
                return `State: ${filter.state}`;

            if (filter.filterBy === this.filterTypes.specific) {
                if (filter.isRegex)
                    return `Sku: /${filter.sku}/`;
                else
                    return `Sku: ${filter.sku}`;
            }

            return "Unknown";
        },
        updateTopicFilters() {
            // Added New Topic from EZ filter
            for (let i = 0; i < this.topicFilters.length; ++i) {
                if (this.page.filters.findIndex((a) => a.topic === this.topicFilters[i].topic) === -1)
                    this.page.filters.push(this.topicFilters[i]);
            }

            // Removed topic from EZ Filter
            for (let i = 0; i < this.page.filters.length; ++i) {
                let pageFilter = this.page.filters[i];
                if (pageFilter.filterBy !== this.filterTypes.topic)
                    continue;

                if (this.topicFilters.findIndex((a) => a.topic === pageFilter.topic) === -1)
                    this.page.filters.splice(i, 1);
            }
            this.filterProducts();
        },
        updateLanguageFilters() {
            // Added language from EZ filter
            for (let i = 0; i < this.langFilters.length; ++i) {
                if (this.page.filters.findIndex((a) => a.language === this.langFilters[i].language) === -1)
                    this.page.filters.push(this.langFilters[i]);
            }
            // Removed language from EZ filter
            for (let i = 0; i < this.page.filters.length; ++i) {
                let pageFilter = this.page.filters[i];
                if (pageFilter.filterBy !== this.filterTypes.language)
                    continue;

                if (this.langFilters.findIndex((a) => a.language === pageFilter.language) === -1)
                    this.page.filters.splice(i, 1);
            }
            this.filterProducts();
        },
        updateGradeFilters() {
            for (let i = -1; i < Object.keys(this.gradeFilter).length; ++i) {
                if (this.gradeFilter[i] && this.page.filters.findIndex((a) => a.grade === i) === -1) {
                    this.page.filters.push({
                        filterBy: this.filterTypes.grade,
                        type: 'or',
                        grade: i
                    });
                }
            }
            for (let i = 0; i < this.page.filters.length; ++i) {
                if (this.gradeFilter[this.page.filters[i].grade] === false)
                    this.page.filters.splice(i, 1);
            }
            this.filterProducts();
        },
        selectAllStatesForFilter(select = true) {
            if (select)
                this.newFilter.selected_states = [...this.states.slice()];
            else
                this.newFilter.selected_states = [];

            this.$nextTick(() => {
                this.$forceUpdate();
            });

        },

        savePage() {
            this.saving = true;
            this.$store.dispatch('savePage', this.page)
                .then((response) => {
                    console.log(response);
                    this.$swal('saved!');
                    this.$store.dispatch('getPages')
                })
                .finally(() => {
                    this.saving = false
                });
        },
        togglePub(sku) {
            return (checked) => {
                let indexOfSku = this.page.favored_skus.indexOf(sku);
                if (!checked && indexOfSku !== -1)
                    this.page.favored_skus.splice(indexOfSku, 1);
                else if (checked)
                    this.page.favored_skus.push(sku);
            }
        },
        setSelectedMap(item) {
            if (!item.length) {
                this.folderResources = [];
                return;
            }
            this.selectedResourceMap = item[0];
            this.getResources();
        },
        imageUrl: imageUrl,
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_colors.scss";

    .topic-ss {
        color: #0070b9
    }
    .topic-sn {
        color: #006d5f;
    }
    .topic-hw {
        color: #362977;
    }
    .topic-other {
        color: #004e7d;
    }

    .lang-es {
        color: green;
    }
    .lang-en {
        color: blue;
    }

    .pre-k {
        background-color: $prek;
        border-color: darken($prek, 10%);
    }

    .kindergarten {
        background-color: $kindergarten;
        border-color: darken($kindergarten, 10%);
    }

    .first-grade {
        background-color: $first-grade;
        border-color: darken($first-grade, 10%);
    }

    .second-grade {
        background-color: $second-grade;
        border-color: darken($second-grade, 10%);
    }

    .third-grade {
        background-color: $third-grade;
        border-color: darken($third-grade, 10%);
    }

    .fourth-grade {
        background-color: $fourth-grade;
        border-color: darken($fourth-grade, 10%);
        // color: darken($fourth-grade, 40%);
    }

    .fifth-grade {
        background-color: $fifth-grade;
        border-color: darken($fifth-grade, 10%);
    }

    .sixth-grade {
        background-color: $sixth-grade;
        border-color: darken($sixth-grade, 10%);
    }

    .seventh-grade {
        background-color: $seventh-grade;
        border-color: darken($seventh-grade, 10%);
    }

    .eighth-grade {
        background-color: $eighth-grade;
        border-color: darken($eighth-grade, 10%);
    }
</style>

<style scoped>
.filter-delete-btn {
    color: wheat;
}
.filters-list {
    border: 1px solid black;
    border-radius: 5px;
    min-height: 20px;
}
#pub_info {
    color: green;
}
#pub_info:hover {
    cursor: pointer;
}

</style>